import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import classNames from 'classnames';
import { Icon } from '@/components/atoms/Icon';

import styles from './index.module.scss';

export interface TopNavBannerProps extends ComponentPropsWithoutRef<'div'> {
  readonly type: 'primary' | 'secondary';
  readonly icon?: string;
}

export function TopNavBanner({ icon, children, className, type, ...props }: TopNavBannerProps): JSX.Element {
  return (
    <div
      className={classNames(TopNavBanner.displayName, styles.component, className, styles[type || 'primary'])}
      {...props}
    >
      {icon && <Icon id={icon} legacy={false} />}
      <div>{children}</div>
    </div>
  );
}
TopNavBanner.displayName = 'TopNavBanner';
